import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Button } from 'reactstrap';

import './SearchVehicleLicensePlate.scss';

import commonConstant from '../../common/_commonConstant';
import { randomNumber, trimSpace } from '../../common/_commonFunction';
import { fetchGetBuildingByBuildingID, fetchGetLicensePlate, setSearchVehicleType } from '../../actions';
import { Loading } from '../../components';
import {
  buildingRefNumber,
  history,
  IconVehicle,
  isCashier,
  passParamsToPath,
  validateToShowDash,
  validateVehiclePlate,
  vehicleLicensePlate,
  vehicleType,
  vehicleTypeIconName,
  buildingID,
  vehicleProvince,
  InputWithIcon,
  parkingDate,
  RadioButton,
  formatParkingRefNo,
  parkingRefNo,
} from '../../helpers';

class SearchVehicleLicensePlate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'search': '',
      'loading': false,
      'dropdown': false,
      'redirect': null,
      'typeSearch': 'vehicleLicensePlate',
    };
    this.dropdown = createRef();

    if (props.getProfile && (!isCashier(props.getProfile) || (isCashier(props.getProfile) && props.match.params.buildingID !== buildingID(props.getProfile)))) {
      return history.push(commonConstant.pathCheckRedirect);
    } else if (!props.getBuildingByRefNo) {
      props.dispatch(fetchGetBuildingByBuildingID(props.match.params.buildingID));
    }
    props.dispatch(setSearchVehicleType('vehicleLicensePlate'));
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { getProfile, getVehicleLicensePlate, match } = this.props;
    const { redirect } = this.state;

    if (
      (nextProps.getProfile && nextProps.getProfile !== getProfile) ||
      (nextProps.match.url !== match.url && nextProps.getProfile)
    ) {
      if ((!isCashier(nextProps.getProfile) || (isCashier(nextProps.getProfile) && nextProps.match.params.buildingRefNo !== buildingRefNumber(nextProps.getProfile)))) {
        return history.push(commonConstant.pathCheckRedirect);
      }
    } else if (nextProps.getVehicleLicensePlate && nextProps.getVehicleLicensePlate && nextProps.getVehicleLicensePlate !== getVehicleLicensePlate) {
      if (!redirect && nextProps.getVehicleLicensePlate.data && nextProps.getVehicleLicensePlate.data.length > 0) {
        return this.setState({ 'loading': false, 'dropdown': true });
      }
      return this.setState({ 'loading': false });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = event => {
    if (this.dropdown.current && !this.dropdown.current.contains(event.target)) {
      return this.setState({ 'dropdown': false });
    }
  }

  handleChange = event => {
    const { getProfile } = this.props;
    const { typeSearch } = this.state;

    if (validateVehiclePlate(event.target.value)) {
      if (trimSpace(event.target.value).length >= 3) {
        this.setState({ 'search': event.target.value, 'loading': true, 'showDetail': null });
        return this.props.dispatch(fetchGetLicensePlate(
          buildingID(getProfile),
          typeSearch === 'vehicleLicensePlate' ? trimSpace(event.target.value) : null,
          commonConstant.parkingStatusIn,
          typeSearch === 'parkingRef' ? trimSpace(event.target.value) : null,
          true,
        ));
      }
      return this.setState({ 'search': event.target.value });
    }
  }

  handleKeyPress = event => {
    if (event.key === 'Enter') {
      return this.handleSearch();
    }
  }

  handleSearch = value => {
    const { search, typeSearch } = this.state;
    const { getProfile } = this.props;
    const text = value ? value : search;

    if (text) {
      this.setState({ 'loading': true, 'redirect': true });
      return this.props.dispatch(fetchGetLicensePlate(
        buildingID(getProfile),
        typeSearch === 'vehicleLicensePlate' ? trimSpace(text) : null,
        commonConstant.parkingStatusIn,
        typeSearch === 'parkingRef' ? trimSpace(text) : null,
        true,
      ));
    }
    return null;
  }

  handleItems = () => {
    const { getVehicleLicensePlate } = this.props;
    const { dropdown, search, typeSearch } = this.state;

    try {
      if (dropdown && search.length > 2 && getVehicleLicensePlate.data.length > 0) {
        return getVehicleLicensePlate.data.map((ele, index) => (
          <div
            id={`license-plate-item-${index}`}
            className="item"
            key={randomNumber()}
            onClick={() => this.handleSearch(typeSearch === 'parkingRef' ? formatParkingRefNo(parkingRefNo(ele)) : vehicleLicensePlate(ele))}
          >
            <div className="left">
              <div id={`vehicle-icon-${index}`} className="vehicle-icon-container">
                <IconVehicle className="icon" name={vehicleTypeIconName(vehicleType(ele))} />
              </div>
              <div className="vehicle-license-plate-container" id={`license-plate-detail-${index}`}>
                <div id={`license-plate-number-${index}`} className="vehicle-license-plate">
                  {validateToShowDash(typeSearch === 'parkingRef' ? formatParkingRefNo(parkingRefNo(ele)) : vehicleLicensePlate(ele))}
                </div>
                <div id={`vehicle-province-${index}`} className="vehicle-license-plate-province">{vehicleProvince(ele)}</div>
              </div>
            </div>
            <div className="right">
              <span id={`parking-in-date-${index}`} className="date">{parkingDate(ele)}</span>
              <span className="icon-icon_arrow_right"/>
            </div>
          </div>
        ));
      }
      return null;
    } catch (error) {
      return null;
    }
  }

  handleTypeSearch = typeSearch => {
    const { search } = this.state;
    const { getProfile } = this.props;

    this.setState({ typeSearch });
    this.props.dispatch(setSearchVehicleType(typeSearch));
    if (search.length >= 3) {
      return this.props.dispatch(fetchGetLicensePlate(
        buildingID(getProfile),
        typeSearch === 'vehicleLicensePlate' ? trimSpace(search) : null,
        commonConstant.parkingStatusIn,
        typeSearch === 'parkingRef' ? trimSpace(search) : null,
        true,
      ));
    }
  }

  render() {
    const { search, loading, redirect, dropdown, typeSearch } = this.state;
    const { getProfile, getBuildingByRefNo, match, getVehicleLicensePlate } = this.props;

    if (!getProfile || !getBuildingByRefNo) {
      return <Loading />;
    } else if (redirect && !loading) {
      return <Redirect to={passParamsToPath(commonConstant.pathParkingStatus, match.params)} />;
    }

    return (
      <div className="SearchVehicleLicensePlate no-sidebar-layout">
        {loading ? <Loading /> : null}
        <div className="box-search">
          <div className="box-title">
            <div id="search-icon" className="icon fas fa-search" />
            <div id="search-title" className="title">ค้นหาทะเบียนรถ</div>
          </div>
          <div className="box-search-type">
            <RadioButton
              x2
              id="filter-search-by-vehicle-license-plate"
              checked={typeSearch === 'vehicleLicensePlate'}
              label="ทะเบียนรถ"
              handleSelect={() => this.handleTypeSearch('vehicleLicensePlate')}
            />
            <RadioButton
              x2
              id="filter-search-by-parking-ref"
              checked={typeSearch === 'parkingRef'}
              label="รหัสอ้างอิง"
              handleSelect={() => this.handleTypeSearch('parkingRef')}
            />
          </div>
          <div className="search-dropdown">
            <div className={`box-dropdown${dropdown && search.length > 2 && getVehicleLicensePlate.data.length > 0 ? ' active' : ''}`}>
              <InputWithIcon
                id="search-license-plate"
                template="f"
                placeholder={typeSearch === 'vehicleLicensePlate' ? 'กรอกเลขทะเบียนรถ' : 'กรอกรหัสอ้างอิง'}
                value={search}
                onClick={() => this.handleSearch()}
                onChange={this.handleChange}
                onKeyPress={this.handleKeyPress}
                maxLength="9"
              />
              <div className="dropdown" ref={this.dropdown}>
                {this.handleItems()}
              </div>
            </div>
          </div>
          <div className="search-button-container">
            <Button id="search-button" onClick={() => this.handleSearch()} className="search-button btn-primary">ค้นหา</Button>
          </div>
        </div>
      </div>
    );
  }
}

SearchVehicleLicensePlate.propTypes = {
  'dispatch': PropTypes.func.isRequired,
  'match': PropTypes.shape({
    'params': PropTypes.shape({
      'buildingID': PropTypes.string,
      'buildingRefNo': PropTypes.string,
    }),
    'url': PropTypes.string,
  }),
  'getProfile': PropTypes.shape({}),
  'getVehicleLicensePlate': PropTypes.shape({
    'data': PropTypes.array,
    'status': PropTypes.any,
  }),
  'getBuildingByRefNo': PropTypes.shape({}),
};

const mapStateToProps = ({ getVehicleLicensePlate, getProfile, getBuildingByRefNo, searchVehicleType }) => ({
  getVehicleLicensePlate,
  'getProfile': getProfile.data,
  'getBuildingByRefNo': getBuildingByRefNo.data,
  searchVehicleType,
});

export default connect(mapStateToProps)(SearchVehicleLicensePlate);
